import slugify from '@sindresorhus/slugify'
import { DecoratedList, DecoratedListItem, type DecoratedListProps } from '@shc/ui'
import type { TypeListFields } from '@lib/generated-types'
import { richTextRenderFactory } from '@lib/rich-text-options'

type ListProps = DecoratedListProps & TypeListFields

const List = ({ internalName, sectionLink, items, listStyle, ...props }: Readonly<ListProps>) => (
  <DecoratedList id={sectionLink && slugify(sectionLink)} {...props}>
    {items.map(({ fields: { title, description }, sys: { id } }, index) => (
      <DecoratedListItem
        key={id}
        heading={title}
        description={richTextRenderFactory()(description) ?? ''}
        slots={{ description: 'span' }}
        decorator={listStyle === 'number' ? `${index + 1}` : undefined}
      />
    ))}
  </DecoratedList>
)

export default List
